
import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot";
import axios from "axios";

export const getClientList = createAsyncThunk('/thunk/get-client-list', async () => {
    try {
        const response = await axios.post(`${baseUrl}cleaningappfunctions/utils/app/v1/get-client-list`,{page:1})
        return response
    } catch (error) {
        throw error
    }});